import { render, staticRenderFns } from "./ClientConflictForm.vue?vue&type=template&id=4d137586&"
import script from "./ClientConflictForm.vue?vue&type=script&lang=js&"
export * from "./ClientConflictForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientConflictForm.vue?vue&type=style&index=0&id=4d137586&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports